import React, {useEffect} from 'react';
import {purchaseToken} from "../../services/ProductRepository";
import {useParams} from "react-router-dom";
import Header from "../../components/navigation/Header";
import {useError} from "../../hooks/useError";


export function PurchaseProduct() {

    const params = useParams();
    const {setErrorMessage} = useError();

    useEffect(() => {
        purchaseToken(params.id, setErrorMessage).then(result => {
            window.location.href = result.redirectUrl
        }).catch(err => console.log(err))
    }, []);


    return (
        <div className={""}>
            <Header/>

        </div>

    );

}